import { render, staticRenderFns } from "./TransportationLinesList.vue?vue&type=template&id=b1c23620&scoped=true"
import script from "./TransportationLinesList.vue?vue&type=script&lang=js"
export * from "./TransportationLinesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c23620",
  null
  
)

export default component.exports